<template>
    <div id="onlineResidenceApplication">
        <!-- Photo uploader -->
        <!-- <photo-uploader :photoData="photoData"></photo-uploader> -->

        <!-- Online residence application -->
        <v-stepper v-model="step" alt-labels non-linear>
            <v-stepper-header>
                <!-- Step 1 - Personal Information -->
                <v-stepper-step :color="kingsGreen" :complete="step > 1" step="1">
                    Personal Information
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 2 - Parent Contact Information -->
                <v-stepper-step :color="kingsGreen" :complete="step > 2" step="2">
                    Emergency Contact Information
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 3 - Residence Experience - Building Preference -->
                <v-stepper-step :color="kingsGreen" :complete="step > 3" step="3">
                    Residence Experience - Building Preference
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 4 - Residence Experience - Accommodation Considerations -->
                <v-stepper-step :color="kingsGreen" :complete="step > 4" step="4">
                    Residence Experience - Accommodation Consideration(s) (Optional)
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 5 - Residence Experience - Placement Preferences -->
                <v-stepper-step :color="kingsGreen" :complete="step > 5" step="5">
                    <span v-if="user.isResidenceAssistant == '1'">
                        General Information
                    </span>
                    <span v-else>
                        Residence Experience - Placement Preference
                    </span>
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 6 - Rules Of Residence -->
                <v-stepper-step :color="kingsGreen" :complete="step > 6" step="6">
                    Rules of Residence
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 7 - Residence Agreement form -->
                <v-stepper-step :color="kingsGreen" :complete="step > 7" step="7">
                    Residence Agreement Form
                </v-stepper-step>
                <v-divider></v-divider>

                <!-- Step 8 - Payment Method -->
                <v-stepper-step v-if="user.isResidenceAssistant != '1'" :color="kingsGreen" :complete="step > 8"
                    step="8">
                    Payment Method
                </v-stepper-step>
                <v-divider v-if="user.isResidenceAssistant != '1'"></v-divider>

                <!-- Step 9 - Submission -->
                <v-stepper-step v-if="user.isResidenceAssistant == '1'" :color="kingsGreen" :complete="step > 8"
                    step="8">
                    Submission
                </v-stepper-step>
                <v-stepper-step v-else :color="kingsGreen" :complete="step > 9" step="9">
                    Submission
                </v-stepper-step>
            </v-stepper-header>

            <!-- Step 1 - Personal Information -->
            <v-stepper-content step="1">
                <personal-information-form ref="personalInformation" :announcement="getIntroAnnouncement"
                    :applicant="applicant" :formSettings="formSettings" :photoData="photoData"
                    :residenceTermsAppliedTo="residenceTermsAppliedTo" :user="user"
                    :validStudentnumber="validStudentnumber" @setStep="setStep" @scrollToTop="scrollToTop">
                </personal-information-form>
            </v-stepper-content>

            <!-- Step 2 - Parent Contact Information -->
            <v-stepper-content step="2">
                <emergency-contact-information-form ref="emergencyContactInformation" :applicant="applicant"
                    @setStep="setStep" @scrollToTop="scrollToTop">
                </emergency-contact-information-form>
            </v-stepper-content>

            <!-- Step 3 - Residence Experience - Building Preference -->
            <v-stepper-content step="3">
                <residence-assistant-building-preference-form v-if="user.isResidenceAssistant == '1'"
                    ref="buildingPreference" :applicant="applicant" :formSettings="formSettings" :user="user"
                    @setStep="setStep" @scrollToTop="scrollToTop">
                </residence-assistant-building-preference-form>
                <building-preference-form v-else ref="buildingPreference" :applicant="applicant"
                    :formSettings="formSettings" :user="user" @resetBuildingOption1="resetBuildingOption1"
                    @resetBuildingOption2="resetBuildingOption2" @resetRoommateOption1="resetRoommateOption1"
                    @resetRoommateOption2="resetRoommateOption2" @setStep="setStep" @scrollToTop="scrollToTop">
                </building-preference-form>
            </v-stepper-content>

            <!-- Step 4 - Residence Experience - Accommodation Considerations -->
            <v-stepper-content step="4">
                <accommodation-consideration-form ref="accommodationConsideration" :applicant="applicant"
                    @setStep="setStep" @scrollToTop="scrollToTop">
                </accommodation-consideration-form>
            </v-stepper-content>

            <!-- Step 5 - Residence Experience - Placement Preferences -->
            <v-stepper-content step="5">
                <residence-assistant-general-information-form v-if="user.isResidenceAssistant == '1'"
                    ref="placementPreference" :applicant="applicant" :photoData="photoData" @setNotification="setNotification"
                    @addTrainingDayMissed="addTrainingDayMissed" @removeTrainingDayMissed="removeTrainingDayMissed"
                    @setStep="setStep" @scrollToTop="scrollToTop">
                </residence-assistant-general-information-form>
                <placement-preference-form v-else ref="placementPreference" :applicant="applicant" :photoData="photoData"
                    @setNotification="setNotification" @setStep="setStep" @scrollToTop="scrollToTop">
                </placement-preference-form>
            </v-stepper-content>

            <!-- Step 6 - Rules of Residence -->
            <v-stepper-content step="6">
                <rules-of-residence-form :applicant="applicant" @setStep="setStep" @scrollToTop="scrollToTop" ></rules-of-residence-form>
            </v-stepper-content>

            <!-- Step 7 - Residence Agreement form -->
            <v-stepper-content step="7">
                <!-- <residence-agreement-form-v1 ref="residenceAgreement" :applicant="applicant"
                    :isResidenceAssistant="user.isResidenceAssistant" :submitBool="submitBool" @setStep="setStep"
                    @scrollToTop="scrollToTop" @submitForm="submitForm">
                </residence-agreement-form-v1> -->
                <residence-agreement-form-v2 ref="residenceAgreement" :applicant="applicant"
                    :isResidenceAssistant="user.isResidenceAssistant" :submitBool="submitBool" @setStep="setStep"
                    @scrollToTop="scrollToTop" @submitForm="submitForm">
                </residence-agreement-form-v2>
            </v-stepper-content>

            <!-- Step 8 - Payment Method -->
            <v-stepper-content v-if="user.isResidenceAssistant != '1'" step="8">
                <payment-method-form ref="paymentMethod" :announcement="getPresubmitAnnouncement" :applicant="applicant"
                    :submitBool="submitBool" @setNotification="setNotification" @setStep="setStep"
                    @submitForm="submitForm" @scrollToTop="scrollToTop">
                </payment-method-form>
            </v-stepper-content>

            <!-- Step 9 - Submission -->
            <v-stepper-content class="pa-0" :step="user.isResidenceAssistant == '1' ? '8' : '9'">
                <residence-application-submission ref="residenceApplicationSubmission" :applicant="applicant"
                    :submission="submission">
                </residence-application-submission>
            </v-stepper-content>
        </v-stepper>
    </div>
</template>

<script>
import auth from '../../../js/auth';
import AccommodationConsiderationForm from './ResidenceApplication/AccommodationConsideration';
import BuildingPreferenceForm from './ResidenceApplication/BuildingPreference';
import EmergencyContactInformationForm from './ResidenceApplication/EmergencyContactInformation';
import PaymentMethodForm from './ResidenceApplication/PaymentMethod';
import PersonalInformationForm from './ResidenceApplication/PersonalInformation';
// import PhotoUploader from './PhotoUploader.vue';
import PlacementPreferenceForm from './ResidenceApplication/PlacementPreference';
import RulesOfResidenceForm from "./ResidenceAgreement/RulesOfResidence.vue";
//import ResidenceAgreementFormV1 from './ResidenceAgreement/ResidenceAgreementV1';
import ResidenceAgreementFormV2 from './ResidenceAgreement/ResidenceAgreementV2';
import ResidenceApplicationSubmission from './ResidenceApplication/Submission';
import ResidenceAssistantBuildingPreferenceForm from './ResidenceAssistance/BuildingPreference';
import ResidenceAssistantGeneralInformationForm from './ResidenceAssistance/GeneralInformation';

export default {
    name: 'online-residence-application-form',
    components: {
        AccommodationConsiderationForm,
        BuildingPreferenceForm,
        EmergencyContactInformationForm,
        PaymentMethodForm,
        PersonalInformationForm,
        // PhotoUploader,
        PlacementPreferenceForm,
        RulesOfResidenceForm,
        //ResidenceAgreementFormV1,
        ResidenceAgreementFormV2,
        ResidenceApplicationSubmission,
        ResidenceAssistantBuildingPreferenceForm,
        ResidenceAssistantGeneralInformationForm
    },
    props: {
        user: {
            required: true
        }
    },
    data() {
        return {
            announcements: [],
            applicant: {
                prefpronoun: '',
                sixftorover: "no",
                sixftoroverdetail: '',
                applicationRole: 'student',
                emailPersonalConfirmed: "",
                officeUse: {},
                parentGuardianEmergencyContact: {},
                residenceAgreement: {
                    applicantSignatureDate: new Date().toISOString().slice(0, 10),
                    parentSignatureDate: new Date().toISOString().slice(0, 10),
                    version: '20191201'
                },
                roommateRequest01: [],
                roommateRequest02: [],
                requestSuperSingle: 'no',
                requestSingleRoom: 'no',
                specialAccommodationAgreeToTerms: '',
                specialAccommodationBasis: '',
                specialAccommodationConsideration: '',
                specialAccommodationDescription: '',
                rulesOfResidence: {
                    agreement: "may2025",
                    signed: "no"
                }
            },
            formSettings: {
                mealPlans: []
            },
            photoData: {
                image: '',
                issuance: '',
                status: ''
            },
            provinceItems: [{
                    text: 'Alberta',
                    value: 'AB'
                },
                {
                    text: 'British Columbia',
                    value: 'BC'
                },
                {
                    text: 'Manitoba',
                    value: 'MB'
                },
                {
                    text: 'New Brunswick',
                    value: 'NB'
                },
                {
                    text: 'Newfoundland and Labrador',
                    value: 'NL'
                },
                {
                    text: 'Northwest Territories',
                    value: 'NT'
                },
                {
                    text: 'Nova Scotia',
                    value: 'NS'
                },
                {
                    text: 'Nunavut',
                    value: 'NU'
                },
                {
                    text: 'Ontario',
                    value: 'ON'
                },
                {
                    text: 'Prince Edward Island',
                    value: 'PE'
                },
                {
                    text: 'Quebec',
                    value: 'QC'
                },
                {
                    text: 'Saskatchewan',
                    value: 'SK'
                },
                {
                    text: 'Yukon',
                    value: 'YT'
                },
                {
                    text: 'Other',
                    value: 'Other'
                }
            ],
            residenceTermsAppliedTo: [],
            step: 1,
            submission: 'danger',
            submitBool: false,
            validStudentnumber: false
        }
    },
    methods: {
        addTrainingDayMissed(item) {
            this.applicant.trainingDaysMissed.push(item);
        },
        getRulesOfResidenceText(){

        },
        async getApplicantData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicant`;

            // GET request
            await fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Your application information could not be retrieved. Please contact your system administrator.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else {
                        // Resolve applicant
                        that.applicant = json.data;
                        that.announcements = json.announcements || [];
                        that.formSettings = json.formSettings;
                        that.residenceTermsAppliedTo = json.residenceTermsAppliedTo || [];

                        // Office use
                        that.applicant.officeUse = {};

                        // Emergency contact
                        that.applicant.parentGuardianEmergencyContact = {};

                        // Residence agreement
                        that.applicant.residenceAgreement = {
                            applicantSignatureDate: new Date().toISOString().slice(0, 10),
                            parentSignatureDate: new Date().toISOString().slice(0, 10),
                            version: '20191201'
                        };

                        //Rules of Residence
                        //June 2025 - Update Versions here
                        that.applicant.rulesOfResidence = {
                            agreement: "may2025",
                            signed: "no"
                        }

                        // Resolve email if needed
                        if (!that.applicant.email) {
                            that.applicant.email = `${auth.getUser().username}@uwo.ca`;
                        }

                        // Resolve student number
                        if (that.applicant.studentnumber) {
                            that.validStudentnumber = true;
                        }

                        // Default optional keys
                        that.applicant.applicantRole = 'student';
                        that.applicant.roommateRequest01 = [];
                        that.applicant.roommateRequest02 = [];
                        that.applicant.requestSuperSingle = 'no';
                        that.applicant.requestSingleRoom = 'no';
                        that.applicant.specialAccommodationAgreeToTerms = '';
                        that.applicant.specialAccommodationBasis = '';
                        that.applicant.specialAccommodationConsideration = '';
                        that.applicant.specialAccommodationDescription = '';
                        that.applicant.prefpronoun = '';
                        that.applicant.sixftorover = "no";
                        that.applicant.sixftoroverdetail = "";

                        that.applicant.emailPersonalConfirmed = "";
                        
                        // Residence Assistant keys
                        if (that.user.isResidenceAssistant == "1") {
                            that.applicant.allergiesConcern = '';
                            that.applicant.applicantRole = 'residenceAssistant';
                            that.applicant.trainingDaysMissed = [];
                        }
                    }

                    // Resolve province
                    that.resolveProvince();

                    // Reset form validations
                    that.$refs.personalInformation.resetForm();
                    that.$emit('setLoader', false);
                })
                .catch(function () {
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred during the retrieval of your application information. Please contact a system administrator.`, true);
                    that.$emit('setLoader', false);
                })
        },
        getApplicantIssuance(username) {
            const that = this;
            const formData = new FormData();
            let api =
                `https://${location.hostname}/cgi-bin/snapshot-api/api.service.pl?getClient`;

            // Parse array into string
            formData.append('data', JSON.stringify({
                username: username
            }));
            formData.append('mode', 'getClient');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Token': '5dfac020a2044e28787a7693d36b8874874c713fccc078aa148b100500b97229ff5848550d59a5e9fed942d9c40e89cc33b3eeca302043c51d997ced6899dae2',
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.photoData.issuance = json.issuance ? json.issuance : that.photoData.issuance;
                    } else {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `An error occurred. ${json.message}.`, true);
                    }

                    // Retrieve user photo
                    that.getApplicantPhoto(that.user.username);
                })
                .catch(function () {
                    // Retrieve user photo
                    that.getApplicantPhoto(that.user.username);
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        getApplicantPhoto(username) {
            const that = this;
            const formData = new FormData();
            let api =
                `https://${location.hostname}/cgi-bin/snapshot-api/api.service.pl?getPhoto`;

            // Parse array into string
            formData.append('data', JSON.stringify({
                username: username
            }));
            formData.append('mode', 'getPhoto');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Token': '5dfac020a2044e28787a7693d36b8874874c713fccc078aa148b100500b97229ff5848550d59a5e9fed942d9c40e89cc33b3eeca302043c51d997ced6899dae2',
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // // Success result
                    if (json.result.match(/OK/i)) {
                        that.photoData.image = json.data.image && json.data.image.image ? json.data.image.image : that.photoData.image;
                        that.photoData.status = json.data.client && json.data.client.status ? json.data.client.status : that.photoData.status;
                    } else {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `An error occurred. ${json.message}.`, true);
                    }
                })
                .catch(function () {
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        removeTrainingDayMissed(index) {
            this.applicant.trainingDaysMissed.splice(index, 1);
        },
        resetBuildingOption1() {
            this.applicant.buildingOption01 = '';
        },
        resetBuildingOption2() {
            this.applicant.buildingOption02 = '';
        },
        resetRoommateOption1() {
            this.applicant.roommateRequest01 = [];
        },
        resetRoommateOption2() {
            this.applicant.roommateRequest02 = [];
        },
        resolveProvince() {
            if (this.applicant.hasOwnProperty('province') && this.applicant.province) {
                let bool = false;

                for (let i = 0; i < this.provinceItems.length; i++) {
                    if (this.applicant.province == this.provinceItems[i].text || this.applicant.province == this.provinceItems[i].value) {
                        bool = true;
                        break;
                    }
                }

                if (!bool) {
                    this.applicant.provinceOther = this.applicant.province;
                    this.applicant.province = "Other";
                }
            }
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        },
        setStep(val) {
            this.step = val;
        },
        scrollToTop() {
            this.$vuetify.goTo(1, {
                duration: 200,
                offset: 0,
                easing: "easeInOutCubic"
            });
        },
        submitForm() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?submitApplication`;

            // Parse array into string
            formData.append('mode', 'submitApplication');
            formData.append('data', JSON.stringify(this.applicant));

            // Loading icon
            this.submitBool = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.submission = 'success';
                    } else if (json.message.match(/already.*applied/i)) {
                        that.submission = 'warning';
                    } else {
                        that.submission = 'danger';
                    }

                    if (that.user.isResidenceAssistant == "1") {
                        that.$refs.residenceAgreement.closeSubmitDialog();
                        that.setStep(8);
                    } else {
                        that.$refs.paymentMethod.closeSubmitDialog();
                        that.setStep(9);
                    }
                })
                .catch(function () {
                    that.submission = 'danger';
                    if (that.user.isResidenceAssistant == "1") {
                        that.$refs.residenceAgreement.closeSubmitDialog();
                        that.setStep(8);
                    } else {
                        that.$refs.paymentMethod.closeSubmitDialog();
                        that.setStep(9);
                    }
                });
        }
    },
    computed: {
        getIntroAnnouncement() {
            let announcement = {
                class: '',
                enabled: false,
                text: ''
            }

            for (let i = 0; i < this.announcements.length; i++) {
                if (this.announcements[i].hasOwnProperty('announcement-location') && this.announcements[i]['announcement-location'].match(/intro/gi)) {
                    announcement.class = this.announcements[i]['announcement-class'];
                    announcement.enabled = true;
                    announcement.text = this.announcements[i]['announcement'];
                }
            }

            return announcement;
        },
        getPresubmitAnnouncement() {
            let announcement = {
                class: '',
                enabled: false,
                text: ''
            }

            for (let i = 0; i < this.announcements.length; i++) {
                if (this.announcements[i].hasOwnProperty('announcement-location') && this.announcements[i]['announcement-location'].match(/presubmit/gi)) {
                    announcement.class = this.announcements[i]['announcement-class'];
                    announcement.enabled = true;
                    announcement.text = this.announcements[i]['announcement'];
                }
            }

            return announcement;
        },
        kingsGreen() {
            return '#004236';
        }
    },
    created() {
        this.getApplicantData().then(() => {
            //this.getApplicantIssuance(this.user.username);
        });
    }
}
</script>